import JobStatus from './JobStatus'
import moment from 'moment'

const ModulesUtils = {

  /**
   * Job screen modules
   */
  genericComparer() {
    const priority = [
      'displayName', 'address', 'description', 'date',
      'contactInfo',
      'clocking', 'clockingTeam', 'clockingExtended', 'clockingExtendedTeam', 'clockingWorker', 'clockingLineItems', 'status',
      'workers', 'assistants', 'laborers',
      'lineItems',
      'tasks', 'sharedTasks', 'tasksRecurrent', 'tasksInstance',
      'materials', 'photos',
      'notes', 'notesTeam', 'sharedNotesTeam', 'notesExtended']
    return (module1, module2) => {
      return priority.indexOf(module1) - priority.indexOf(module2)
    }
  },

  sortModules(modules) {
    // Get the comparator function, specific for each job template
    const comparer = ModulesUtils.genericComparer()
    modules.sort(comparer)
  },

  getMemberName: (members, id) => {
    const member = members.find(m => m.userId === id)
    return member && member.displayName || 'No Name'
  },

  getMemberEmail: (members, id) => {
    const member = members.find(m => m.userId === id)
    return member && member.email || null
  },

  getFirstInProgressShifts: function(shifts) {
    for (let i = 0; i < shifts.length; i++) {
      if (shifts[i]._type === 'deleted') {
        continue;
      }

      if (!shifts[i].timeIn || !shifts[i].timeOut) {
        return shifts[i];
      }
    }

    return undefined;
  },

  getJobClockingTeamState: function(clockingTeamModule) {
    for (const key in clockingTeamModule) {
      if (!clockingTeamModule.hasOwnProperty(key)) {
        continue;
      }

      const jobClockingState = ModulesUtils.getJobClockingState(clockingTeamModule[key])
      if (jobClockingState !== JobStatus.NOT_STARTED) {
        return jobClockingState
      }
    }

    return JobStatus.NOT_STARTED
  },

  getJobStateFromStatusModule: statusModule => {
    if (statusModule.value === 'accepted' || statusModule.value === 'onhold') {
      return JobStatus.IN_PROGRESS
    }
    if (statusModule.value === 'completed') {
      return JobStatus.COMPLETED
    }
    return JobStatus.NOT_STARTED
  },

  getJobClockingState: function(clockingModule) {
    if (!clockingModule || !clockingModule.timeIn) {
      return JobStatus.NOT_STARTED
    }

    if (!clockingModule.timeOut) {
      return JobStatus.IN_PROGRESS
    }

    if (!clockingModule.shifts) {
      return JobStatus.COMPLETED
    }

    const shift = ModulesUtils.getFirstInProgressShifts(clockingModule.shifts);
    if (!shift) {
      return JobStatus.COMPLETED
    }

    if (!shift.timeIn) {
      return JobStatus.PAUSED
    }

    if (!shift.timeOut) {
      return JobStatus.IN_PROGRESS
    }

    return JobStatus.COMPLETED
  },

  getRecurrenceSummary(dateInfo) {
    const recurrence = dateInfo.recurrence;
    let summaryText = '';
    if (!recurrence) {
      return summaryText;
    }

    if (recurrence.repeats === 'weekly') {
      if (recurrence.repeatOcurrency === 1) {
        summaryText += 'Weekly';
      } else {
        summaryText += `Every ${recurrence.repeatOcurrency} weeks`;
      }

      let firstDay = true;
      for (const key in recurrence.repeatOn) {
        if (recurrence.repeatOn[key]){
          const weekday = moment().isoWeekday(parseInt(key)).format('dddd');
          if (firstDay) {
            summaryText += ` on ${weekday}`
          } else {
            summaryText += `, ${weekday}`
          }
          firstDay = false;
        }
      }
    } else if (recurrence.repeats === 'monthly') {
      if (recurrence.repeatOcurrency === 1) {
        summaryText += 'Monthly';
      } else {
        summaryText += `Every ${recurrence.repeatOcurrency} months`;
      }

      if (recurrence.repeatBy === 'dayOfTheMonth') {
        const monthday = moment(dateInfo.startDate).date();
        summaryText += ` on day ${monthday}`
      } else {
        const startDate = moment(dateInfo.startDate);
        const monthday = startDate.format('dddd');
        const numberOfDays = Math.floor((startDate.date() - 1) / 7);
        const NUMBER_TO_TEXT = ['first', 'second', 'third', 'fourth', 'fifth']
        const numberOfDaysText = NUMBER_TO_TEXT[numberOfDays];

        summaryText += ` on the ${numberOfDaysText} ${monthday}`
      }
    }

    return summaryText
  }
}

export default ModulesUtils



// WEBPACK FOOTER //
// ./src/infra/ModulesUtils.js